function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import $ from 'dom7';
import Utils from '../../utils/utils';

var TouchRipple = /*#__PURE__*/function () {
  function TouchRipple($el, x, y) {
    _classCallCheck(this, TouchRipple);

    var ripple = this;
    if (!$el) return undefined;
    var box = $el[0].getBoundingClientRect();
    var center = {
      x: x - box.left,
      y: y - box.top
    };
    var width = box.width;
    var height = box.height;
    var diameter = Math.max(Math.pow(Math.pow(height, 2) + Math.pow(width, 2), 0.5), 48);
    ripple.$rippleWaveEl = $("<div class=\"ripple-wave\" style=\"width: ".concat(diameter, "px; height: ").concat(diameter, "px; margin-top:-").concat(diameter / 2, "px; margin-left:-").concat(diameter / 2, "px; left:").concat(center.x, "px; top:").concat(center.y, "px;\"></div>"));
    $el.prepend(ripple.$rippleWaveEl);
    ripple.rippleTransform = "translate3d(".concat(-center.x + width / 2, "px, ").concat(-center.y + height / 2, "px, 0) scale(1)");
    Utils.nextFrame(function () {
      if (!ripple || !ripple.$rippleWaveEl) return;
      ripple.$rippleWaveEl.transform(ripple.rippleTransform);
    });
    return ripple;
  }

  _createClass(TouchRipple, [{
    key: "destroy",
    value: function destroy() {
      var ripple = this;

      if (ripple.$rippleWaveEl) {
        ripple.$rippleWaveEl.remove();
      }

      Object.keys(ripple).forEach(function (key) {
        ripple[key] = null;
        delete ripple[key];
      });
      ripple = null;
    }
  }, {
    key: "remove",
    value: function remove() {
      var ripple = this;
      if (ripple.removing) return;
      var $rippleWaveEl = this.$rippleWaveEl;
      var rippleTransform = this.rippleTransform;
      var removeTimeout = Utils.nextTick(function () {
        ripple.destroy();
      }, 400);
      ripple.removing = true;
      $rippleWaveEl.addClass('ripple-wave-fill').transform(rippleTransform.replace('scale(1)', 'scale(1.01)')).transitionEnd(function () {
        clearTimeout(removeTimeout);
        Utils.nextFrame(function () {
          $rippleWaveEl.addClass('ripple-wave-out').transform(rippleTransform.replace('scale(1)', 'scale(1.01)'));
          removeTimeout = Utils.nextTick(function () {
            ripple.destroy();
          }, 700);
          $rippleWaveEl.transitionEnd(function () {
            clearTimeout(removeTimeout);
            ripple.destroy();
          });
        });
      });
    }
  }]);

  return TouchRipple;
}();

export { TouchRipple as default };